import React, { useEffect, useState, useRef } from 'react';
import '../css/display.css'
import { getRoomsWithAvailability } from '../api/room-api';
import { getCompany } from '../api/company-api'
import { QuickBooking } from '../shared/overlays/quickBooking'
import { formatDateToTime } from '../utils/dateTimeUtils'
import { useConfig } from '../providers/configProvider';
import PreferencesPopup from '../shared/overlays/systemAccountSetup';
import { useLanguage } from '../providers/preferenceProvider';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NavBar from '../shared/bar/navbar';
import EmptyBar from '../shared/bar/emptybar';

const Display = () => {
  const { config } = useConfig();
  const userId = config.user.id;
  const overlayTimerRef = useRef(null);
  const [roomId, setRoomId] = useState(() => {
    return localStorage.getItem('selectedRoomId') || null;
  });
  const { t } = useLanguage();
  const [room, setRoom] = useState()
  const [occupied, setOccupied] = useState(false)
  const [currUser, setCurrUser] = useState()
  const [company, setCompany] = useState()
  const [booking, setBooking] = useState()
  const [availability, setAvailability] = useState([])
  const [times, setTimes] = useState([])
  const [hoursShownOnDisplay, setHoursShownOnDisplay] = useState(() => {
    return parseInt(localStorage.getItem('hoursShownOnDisplay'), 10) || 1;
  });

  const [showQuickBookOverlay, setShowQuickBookOverlay] = useState(false)
  const [selectedStartTime, setSelectedStartTime] = useState();
  const [selectedEndTime, setSelectedEndTime] = useState();
  const [showOverlay, setShowOverlay] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState(null);

  const MIN_BOOKING_TIME_MINS = 8;

  useEffect(() => {
    function preventPinch(e) {
      if (e.scale !== 1) {
        e.preventDefault();
      }
    };
    function preventDoubleTapZoom(e) {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    document.addEventListener('gesturestart', preventPinch, { passive: false });
    document.addEventListener('touchmove', preventDoubleTapZoom, { passive: false });
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('gesturestart', preventPinch);
      document.removeEventListener('touchmove', preventDoubleTapZoom);
      document.body.style.overflow = '';
    };
  }, []);

  function openOverlay(startTime, endTime) {
    const qrURL = `${window.location.origin}/book?roomId=${roomId}&start=${encodeURIComponent(startTime.toISOString())}&end=${encodeURIComponent(endTime.toISOString())}`;

    setSelectedStartTime(startTime);
    setSelectedEndTime(endTime);
    setQrCodeUrl(qrURL);
    setShowQuickBookOverlay(true);
  }

  function closeOverlay() {
    if (overlayTimerRef.current) {
      clearTimeout(overlayTimerRef.current);
      overlayTimerRef.current = null;
    }
    setShowQuickBookOverlay(false);
    setSelectedStartTime(undefined);
    setSelectedEndTime(undefined);
    fetchData();
  }

  function fetchData() {
    const queryParams = new URLSearchParams();
    queryParams.append('date', (new Date()).toISOString());
    queryParams.append('roomId', roomId)
    queryParams.append('active', 'true');
    queryParams.append('includeFiltered', 'false');
  
    getRoomsWithAvailability(queryParams)
      .then((response) => {
        const room = response.data.find(r => r.id.toString() === roomId?.toString());
        if (room) {
          setRoom(room);
        } else {
          setRoom([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching rooms:', error);
      });
  }

  function isFree(start, end){
    const currBookings = room.Bookings.filter(({ startTime, endTime })=>{
      const bookingStart = new Date(startTime);
      const bookingEnd = new Date(endTime);
      return bookingStart < end && bookingEnd > start;
    })
    if (currBookings.length > 0){
      return false;
    } else {
      return true;
    }
  }

  useEffect(() => {
    if (showQuickBookOverlay) {
      overlayTimerRef.current = setTimeout(() => {
        closeOverlay();
        overlayTimerRef.current = null;
      }, 22000);
      return () => {
        if (overlayTimerRef.current) {
          clearTimeout(overlayTimerRef.current);
          overlayTimerRef.current = null;
        }
      };
    }
  }, [showQuickBookOverlay]);


  useEffect(() => {
    if (!userId) return;
  
    if (!roomId) {
      setShowOverlay(true);
      return;
    }

    //trigger for the fetching of the data every 10 seconds  
    fetchData();
    const interval = setInterval(() => {
      fetchData()
    }, 10 * 1000); //10,000ms = 10 seconds

    return () => clearInterval(interval);
  }, [userId, roomId, hoursShownOnDisplay]);

  useEffect(() => {    
    if (!room || !room.active || !room.Bookings) {
      setAvailability([]);
      setTimes([]);
      return;
    }
    //based on the current time and booking interval of the room, set the upcoming timeslot times for a set value of hours
    const interval = room.interval;
    const amountOfSlots = hoursShownOnDisplay * 60 / interval;
    const rounded = new Date();
    rounded.setMinutes((Math.floor(rounded.getMinutes() / interval) * interval ));
    rounded.setSeconds(0);
    rounded.setMilliseconds(0);
    if(new Date().getMinutes() - rounded.getMinutes() >= interval - MIN_BOOKING_TIME_MINS) {
      rounded.setMinutes((Math.floor(rounded.getMinutes() / interval) * interval ) + interval);
    }

    const slots = [];
    slots.push(rounded)
    
    for (let i = 1; i <= amountOfSlots; i++){
      const temp = new Date(rounded);
      slots.push(new Date(temp.setMinutes(rounded.getMinutes() + i * interval)))
    }
    setTimes(slots)

    //set avaiability for the upcoming amountOfSlots timeslots of interval minutes
    const avail = []
    for (let i = 0; i < slots.length - 1 ; i++){
      //check if there is a start date before or in the slot and an end in or after the slot
      const start = new Date(slots[i]);
      const end = new Date(slots[i + 1]);
      const available = isFree(start, end);
      avail[i] = available;
    }
    setAvailability(avail)
    
    // If it exists, the earlist booking that would prevent quick booking
    const currentBookings = room.Bookings
      .sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
      .filter(({ startTime, endTime })=>{
        const start = new Date(startTime);
        const end = new Date(endTime);
        const now = new Date();
        return now >= new Date( start.getTime() - MIN_BOOKING_TIME_MINS * 60 * 1000 ) && now <= end;
    })
    const isOccupied = currentBookings.length > 0;
    if (isOccupied){
      setOccupied(true);
      setBooking(currentBookings[0]);
    } else {
      setOccupied(false);
      setBooking(undefined);
    }
    if (showQuickBookOverlay && selectedStartTime && selectedEndTime) {
      const start = new Date(selectedStartTime);
      const end = new Date(selectedEndTime);
      const stillAvailable = isFree(start, end);

      if (!stillAvailable) {
        closeOverlay();
      }
    }
    
    //if the room is occupied set the company
    if (isOccupied){
      if (overlayTimerRef.current) {
        clearTimeout(overlayTimerRef.current);
        overlayTimerRef.current = null;
      }
      if (showQuickBookOverlay) {
        closeOverlay();
      }
      const creator = currentBookings[0].Users.find(user => user.UserBooking?.creator === true);
      const companyId = creator.companyId;
      setCurrUser(creator)
      if (companyId){
        getCompany(companyId)
          .then((response) => {
            if (company !== response.data){
              setCompany(response.data)
            }
          })
          .catch((error) => {
            console.error('Error fetching companies:', error);
          });
      }
    };
  }, [room]);
  if (!room) return (
    <div>
      {showOverlay ? (
        <PreferencesPopup
          isOpen={showOverlay}
          onClose={() => setShowOverlay(false)}
          onRoomSelect={(id, hours) => {
            setRoomId(id);
            localStorage.setItem('selectedRoomId', id);
            setHoursShownOnDisplay(hours || 1);
            localStorage.setItem('hoursShownOnDisplay', hours || 1);
            setShowOverlay(false);
          }}
        />
      ) : (null)}
    </div>
  );
  
  return (
    <>
      <EmptyBar roomName={room.name}/>
      <div className = "full-screen">
        {showOverlay ? (
          <PreferencesPopup
            isOpen={showOverlay}
            onClose={() => setShowOverlay(false)}
            onRoomSelect={(id, hours) => {
              setRoomId(id);
              localStorage.setItem('selectedRoomId', id);
              setHoursShownOnDisplay(hours || 1);
              localStorage.setItem('hoursShownOnDisplay', hours || 1);
              setShowOverlay(false);
            }}
          />
        ) : (room.length <= 0) ? (
          <main className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
            <FontAwesomeIcon icon={faBan} className="text-red-500 text-6xl mb-4" />
            <h1 className="text-3xl text-gray-800 mb-2 select-none text-4xl">Unavailable</h1>
            <p className="text-gray-600 select-none text-4xl">
          This room is currently <span className="font-medium text-red-600 select-none">inactive</span>. It might be undergoing maintenance or temporarily closed.
            </p>
          </main>
        ) : (
          <main className={`display-container ${occupied ? "red" : "green"}`}>
            <div className="top-part bg-white rounded-[12px] p-5">
              <div>
                {occupied ? (
                  <div className="ml-6 mr-6 items-center flex flex-col"> 
                    <div className = "select-none text-4xl text-red-600 mb-2"> {t.display.currentlyOccupied} </div>
                  </div>
                ) : (
                  <div className="ml-6 mr-6 items-center flex flex-col">
                    <div className = "text-4xl select-none text-[limegreen] mb-2"> {t.display.free} </div>
                  </div>
                )}
              </div>
              <div className="schedule ml-4 mr-4">
                <ul className="blocks">
                  {availability.map((isAvailable, index) => (
                    <div className='block grow'>
                      <li className="ti" key={`time-${index}`}>
                        {formatDateToTime(times[index])}
                      </li>
                      <div
                        className={`timeslot rounded ${isAvailable ? "timeslot-free" : "timeslot-taken"}`}
                        key={index}
                      ></div>
                    </div>
                  ))}
                </ul>
              </div>
            </div>

            <div className="bottom-part">
              {occupied && company ? (
                <div className ="company-welcome">
                  <div className='rounded overflow-hidden img-display'>
                    <img src={company.image} className='img-display' alt="42Workspace" />
                    </div>
                  <div className="company-welcomeText">
                    <div className="select-none text-4xl"> {t.display.welcome} {company.name}! </div>
                    <div className="select-none text-xl"> {t.display.bookingFrom} {formatDateToTime(booking.startTime)} {t.display.to} {formatDateToTime(booking.endTime)}</div>
                  </div>
                </div>
              ) : occupied ? (
                <div className = "company-welcome">
                  <div className='rounded'>
                    <img src={currUser.image} className='img-display' alt="42Workspace" />
                  </div>
                  <div className="company-welcomeText">
                    <div className="big-text select-none"> {t.display.welcome} {currUser.firstname} </div>
                    <div className="small-text select-none"> {t.display.bookingFrom} {formatDateToTime(booking.startTime)} {t.display.to} {formatDateToTime(booking.endTime)}</div>
                  </div>
                </div>
              ) : (
                <div className = "booking-part">
                  <div className = "book-room text-4xl select-none self-center"> {t.display.quickBook}</div>
                  <ul className = "quick-book gap-4 whitespace-nowrap">
                    {room && times.length > 0 ? (
                      <>
                        {times.slice(1,4).map((endTime)=>{
                          const start = new Date();
                          const end = endTime;
                          const diff = Math.round(((end - start) / (1000 * 60)));
                          return isFree(start,end) ? (
                            <button className = "option-free flex-grow" key={diff} onClick={() => openOverlay(start, end)}>
                              <div className="text-4xl text-center">{diff} {diff !== 1 ? t.display.minutes : t.display.minute} </div>
                              <div className="endtime-booking text-2xl"> {t.display.till} {formatDateToTime(end)}</div>
                            </button>
                          ) : (
                            <div className = "option-taken flex-grow" key={diff}>
                              <div className="text-4xl text-center">{diff} {diff !== 1 ? t.display.minutes : t.display.minute} </div>
                              <div className="endtime-booking text-2xl"> {t.display.till} {formatDateToTime(end)}</div>
                            </div>
                          )
                        })
                        }
                      </>
                    ) : (
                      <></>
                    )}
                  </ul>
                </div>
              )}
            </div>
          </main>)}
      </div>
      {showQuickBookOverlay && selectedEndTime && selectedStartTime && (
        <QuickBooking
          isOpen = {showQuickBookOverlay}
          onClose = {closeOverlay}
          startTime = {selectedStartTime}
          endTime = {selectedEndTime}
          room = {room}
          systemId = {userId}
          qrCodeUrl={qrCodeUrl}
        />
      )}
    </>
  );
};

export default Display;